import * as Sentry from '@sentry/react';

/**
 * Telemetría del canal. Existe porque sin ella una cookie vencida, un `$connect` que rebota y un
 * canal sano son indistinguibles desde afuera: el vendedor deja de recibir avisos y nadie se entera.
 */

/** Reintentos seguidos antes de avisar. Reconectar una vez es normal; insistir cinco veces no. */
export const RECONNECT_ALERT_THRESHOLD = 5;

/** El canal lleva `attempts` reintentos seguidos sin lograr abrir. */
export function reportChannelDown(attempts: number): void {
    Sentry.captureMessage('Canal de avisos caído: el vendedor dejó de recibir avisos de su venta', {
        level: 'warning',
        extra: { attempts },
    });
}

/**
 * Llegó un sobre que este front no entiende — el contrato del lambda cambió y nadie lo notó.
 * Viaja SOLO el `type`: el sobre lleva el `sessionId` y eso no sale del navegador.
 */
export function reportUnreadableEnvelope(type: string | null): void {
    Sentry.captureMessage('Sobre del canal de avisos ilegible', {
        level: 'warning',
        extra: { type },
    });
}
